module.exports = __webpack_public_path__ + "images/icon-stockist-spare-parts.84c735.svg";